export default __webpack_public_path__ + "static/media/karuna-sharma.421b7521.jpg";